class IStackOptions {
    constructor() {
        this.limit = 50;
    }
}
export class Stack {
    static $inject = ['options'];
    constructor(options) {
        this.store = [];
        this.options = options;
    }
    add(val) {
        if (this.stackHasSpace()) {
            this.store = [...this.store, val];
        }
    }
    remove() {
        if (this.stackHasItems()) {
            return this.store.pop();
        }
    }
    removeItemByIndex(index) {
        this.store.splice(index, 1);
    }
    getStore() {
        return this.store;
    }
    clear() {
        this.store = [];
    }
    stackHasSpace() {
        return this.store.length <= this.options?.limit;
    }
    stackHasItems() {
        return this.store.length > 0;
    }
}
Stack.$inject = ['options'];
